import { render, staticRenderFns } from "./MatrizRfmSimulador.vue?vue&type=template&id=56f183a2&scoped=true&"
import script from "./MatrizRfmSimulador.vue?vue&type=script&lang=js&"
export * from "./MatrizRfmSimulador.vue?vue&type=script&lang=js&"
import style0 from "./MatrizRfmSimulador.vue?vue&type=style&index=0&id=56f183a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f183a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
